module.exports = __webpack_public_path__ + "static/img/banner1-5.715aec5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity202305/banner1-5.jpg
// module id = LAzp
// module chunks = 0